import { Card } from "@mui/material";


export interface BasicErrorLabelProps {
    message?: String,
    errors?: String[]
}

export function BasicErrorLabel(props: BasicErrorLabelProps) {

    return (<>
        
            <Card style={{ margin: 5, padding: 1, border: '1px solid #909090', borderRadius: 5, backgroundColor: '#ffffff', color: '#D2042D', textDecoration: 'none', whiteSpace: 'pre-wrap' }}>
                {props.message && <p>{props.message}</p>}
                {props.errors && props.errors.length > 1 && 
                <ul>
                    {props.errors.map((x, index) => (<li key={index}>{x}</li>))}
                </ul>
                }
            </Card>
    </>
    );

}